import React, { useEffect, useRef, useState } from "react";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import Flag from "../../../assets/Icons/US-flag.png";
import userAvatar from "../../../assets/images/avatar.png";
import "./index.css";
import { userNameStyle, role, sideBarMenu, MenuItem } from "./styles";
import { OwnProps, Pages } from "../../Utils/Types";
import ClickAwayListener from '@mui/material/ClickAwayListener';

import LogoutModal from "../../Pages/Logout";

import { isOpenLogoutModal , toggleModal } from '../../Pages/Logout/logoutSlicer'

import { selectTitle, setTitle } from "./store/AppDrawerSlicer";
import { selectAuth } from "../../Pages/Login/store/login.Slice";

import { useAppSelector, useAppDispatch } from "../../hooks";
import NotificationDropDown from "../Elipsis";
import { useSelector, useDispatch } from "react-redux";
import { NotificationReducer } from "../../Slices";

import BreakpointHook from "../../Hook/breakpoint-hook";
import { selectBreakPoints } from "../../Slices/appSlicer";
import OrientationModal from "../Orientation-modal";
import { useMediaQuery } from "@mui/material";

const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export const AppDrawer: React.FC<OwnProps> = (props: OwnProps) => {
  const breakpoints = useAppSelector(selectBreakPoints);

  const dispatcher = useDispatch();
  const toggleNotification = useSelector(
    (state: any) => state.NotificationSlicer.data
  );
  const [isEnter, setIsEnter] = React.useState(0);
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [orientation, setOrientation] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const headerTitle = useAppSelector(selectTitle);
  const user = useAppSelector(selectAuth);

  const iphoneLH = useMediaQuery("(max-height:428px)");
  const iphoneLW = useMediaQuery("(max-width:926px)");

  const handleDrawerOpen = () => {
    setOpen(true);
    mobileDrawerRef.current.style.display = "block";
  };

  const handleDrawerClose = () => {
    setOpen(false);
    mobileDrawerRef.current.style.display = "none";
  };
  const [getId, setGetId] = useState<number>(0);
  const handleSideBarItemClick = (item: MenuItem) => {
  
    if (item.name === Pages.Logout) {
      dispatch(toggleModal(true))

    } else {
      setOpen(false);
      setGetId(item.id);
      dispatch(setTitle(item.name));
    }
   
  };
  // notifications
  const handleNotifications = () => {
    dispatcher(NotificationReducer(!toggleNotification));
  };
  const mobileDrawerRef = useRef<HTMLDivElement>(null!);
  useEffect(() => {
    if (iphoneLH && iphoneLW) {
      setOrientation(true);
      return;
    } else {
      setOrientation(false);
    }
  }, [breakpoints]);

  const handleClickAway = () => {
    dispatcher(NotificationReducer(false));
  }
  useEffect(() => {
    handleDrawerClose();
  }, []);
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      {orientation ? <OrientationModal open={true} /> : ""}
      <AppBar   sx={{ backgroundColor: "#121212" }} position="fixed" open={open}>
        <Toolbar sx={{ justifyContent: "space-between", marginTop: "20px" }}>
          <div className="toolbar-div-1">
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: 5,
                ...(open && { display: "none" }),
              }}
            >
              <ChevronRightIcon />
              {/* <MenuIcon /> */}
            </IconButton>
            <Typography variant="h6" noWrap component="div">
              {headerTitle}
            </Typography>
          </div>
          {open ? (
            " "
          ) : (
            <div className="toolbar-div-2" style={{ position: "relative" }}>
              <MoreHorizIcon />
              <Badge
                sx={{ cursor: "pointer" }}
                color="error"
                onClick={handleNotifications}
                badgeContent={1}
              >
                <NotificationsIcon />
              </Badge>
              
              {toggleNotification ? <NotificationDropDown onClickAway={handleClickAway} />   : null}

              <Avatar alt="us flag" src={Flag} />
            </div>
          )}
        </Toolbar>
      </AppBar>
      {/* big screen drawer */}
      <div className="big-screen">
        <Drawer sx={{zIndex: 1200}} className="sidebar" variant="permanent" open={open}>
          <DrawerHeader
            sx={{ justifyContent: "space-between", marginTop: "20px" }}
          >
            <div className="drawer-header-div">
              <Avatar alt="avatar" src={userAvatar} />
              <div>
                <Typography sx={userNameStyle}>
                  {user?.user?.username}
                </Typography>
                <Typography sx={role}>{user?.user?.role}</Typography>
              </div>
            </div>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </DrawerHeader>

          {/* <Divider /> */}
          <List>
            {sideBarMenu.map((item: MenuItem, index: number) => (
              <ListItem
                onClick={() => handleSideBarItemClick(item)}
                onMouseEnter={() => {
                  setIsEnter(index);
                }}
                onMouseLeave={() => {
                  setIsEnter(index);
                }}
                className="side-bar-item"
                key={item.name}
                disablePadding
                sx={{ display: "block" }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <div>
                    <Avatar
                      alt={""}
                      src={isEnter === index ? item.greyIcon : item.icon}
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                    />
                    <div
                      className={`${getId === index ? "activeBar" : null} `}
                    ></div>
                  </div>
                  <ListItemText
                    className="text"
                    primary={item.name}
                    sx={{
                      color: isEnter === index ? "white" : "#909090",
                      opacity: open ? 1 : 0,
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Drawer>
      </div>
      {/* big drawer ended */}
      {/* small screen drawer started */}
      <div className="small-screen">
        <Drawer ref={mobileDrawerRef} variant="permanent" open={open}>
          <DrawerHeader
            sx={{ justifyContent: "space-between", marginTop: "20px" }}
          >
            <div className="drawer-header-div">
              <Avatar alt="avatar" src={userAvatar} />
              <div>
                <Typography sx={userNameStyle}>
                  {user?.user?.username}
                </Typography>
                <Typography sx={role}>{user?.user?.role}</Typography>
              </div>
            </div>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </DrawerHeader>
          {/* <Divider /> */}
          <div>
            <List>
              {sideBarMenu.map((item: MenuItem, index: number) => (
                <ListItem
                  onClick={() => handleSideBarItemClick(item)}
                  onMouseEnter={() => {
                    setIsEnter(index);
                  }}
                  onMouseLeave={() => {
                    setIsEnter(index);
                  }}
                  className="side-bar-item"
                  key={item.name}
                  disablePadding
                  sx={{ display: "block" }}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <div>
                      <Avatar
                        alt={""}
                        src={isEnter === index ? item.greyIcon : item.icon}
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                      />
                      <div
                        className={`${getId === index ? "activeBar" : null} `}
                      ></div>
                    </div>
                    <ListItemText
                      className="text"
                      primary={item.name}
                      sx={{
                        color: isEnter === index ? "white" : "#909090",
                        opacity: open ? 1 : 0,
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </div>
        </Drawer>
      </div>
      {/* small screen drawer ended */}
      <LogoutModal
      open={useAppSelector(isOpenLogoutModal)}
      />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        {props.children}
      </Box>
    </Box>
  );
};
